import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem("infinity-language") || "fa");
  const isEnglish = language === "en";

  useEffect(() => {
    localStorage.setItem("infinity-language", language);
    document.documentElement.lang = language;
    document.documentElement.dir = isEnglish ? "ltr" : "rtl";
  }, [language, isEnglish]);

  const value = useMemo(() => ({
    language,
    isEnglish,
    direction: isEnglish ? "ltr" : "rtl",
    setLanguage,
    toggleLanguage: () => setLanguage((current) => current === "fa" ? "en" : "fa"),
  }), [language, isEnglish]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used inside LanguageProvider");
  return context;
};
